import React, { useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';

const Application_Setting = () => {


    return (
        <div>
            <Header />
            <div class="breadcrumbs">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 col-lg-12 col-sm-12"> <a href="#"><i class="fa fa-home"></i></a> &gt; <a href="dashboard.html">Dashboard</a> &gt; <a href="javascript:void(0)">Setting</a> &gt; <span class="last-crumb">Application Setting</span></div>
                    </div>
                </div>
            </div>

            <div className="main-container">
                <div className="container-md">
                    <div className="row">
                        <div className="col-sm-9 mx-auto">
                            <div className="show-order-area dashboard">
                                <div className='application-setting-area'>
                                    <h3>Application Setting</h3>

                                    <table className='table table-bordered dataTable resizable'>
  <thead>
    <tr>
      <th colspan="2">Module Name </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Default product list sorting</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Code </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> Name </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Default product type selection</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Box </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> Pieces </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Can sales representative give additional discount ?
<span>(on Invoice Amt)</span></td>
<td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Max percent discount allowed on Invoice</td>
      <td><input type="text" class="form-control" />
      <label class="form-check-label" for="gridRadios1"> 1 -100 % </label>
      </td>
    </tr>
    <tr>
      <td>Check product stock before adding to cart
<span>(if not product can't be added to cart)</span></td>
<td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Display product stock</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Display product with zero stock</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Can sales rep/customer add Half Box while ordering ?</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Show customer name in the picking list</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Location access permission Message</td>
      <td>
        <p>This message will show to the user sales
rep while placing an order, why app want
access location.</p>
        </td>
    </tr>
    <tr>
      <td>Can share invoice in pdf ?
<span>(sales rep)</span></td>
<td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>While entering GRN Expiry date is Mandaory or Not</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td>Allow to accept excess quantity then PO quantity, while GRN</td>
      <td><div className='radiobx'>
          <div class="row">
            <div class="col-sm-10">
              <div class="row">
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="0" />
                  <label class="form-check-label" for="gridRadios1"> Yes </label>
                </div>
                <div class="col-6 form-check">
                  <input class="form-check-input" type="radio" name="split" value="1" />
                  <label class="form-check-label" for="gridRadios2"> No </label>
                </div>
              </div>
            </div>
          </div>
        </div></td>
    </tr>
    <tr>
      <td colspan="2" align="center">
      <button type="button" class="common-popup-btn">Save Changes</button>
      </td>
      
    </tr>
    
  </tbody>
</table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       
        </div>
    );
};

export default Application_Setting;
